import { Store } from '@/core/store/core.store';
import { COURSE_TEMPLATES_STORE } from '../enums/course-templates.enum';
import { IResponseGetCourseTemplates } from '../interfaces/response-get-course-templates.interface';
import { ISetTemplateModeStoreParams } from '../params/set-template-mode-store.params';

export class CourseTemplatesFacade {

  get courseTemplates() {
    return Store.state.CourseTemplates.courseTemplates;
  }

  get purchasedContentTemplates() {
    return Store.state.CourseTemplates.purchasedContentTemplates;
  }

  get myContentTemplates() {
    return Store.state.CourseTemplates.myContentTemplates;
  }

  initCourseTemplates(gradeLevelSelected = null): void {
    return Store.commit(COURSE_TEMPLATES_STORE.INI_COURSE_TEMPLATES, gradeLevelSelected);
  }

  initMyContentTemplates(purchaseTypes): void {
    return Store.commit(COURSE_TEMPLATES_STORE.INIT_MY_CONTENT_TEMPLATE_PAGINATION, purchaseTypes);
  }

  setCourseTemplates(data: IResponseGetCourseTemplates): void {
    return Store.commit(COURSE_TEMPLATES_STORE.SET_COURSE_TEMPLATES, data);
  }

  setPurchasedTemplates(data: IResponseGetCourseTemplates): void {
    return Store.commit(COURSE_TEMPLATES_STORE.SET_PURCHASED_TEMPLATES, data);
  }

  createCourseTemplate({ courseId, isPublic }: { courseId: number, isPublic: boolean }): Promise<void> {
    return Store.dispatch(COURSE_TEMPLATES_STORE.CREATE_COURSE_TEMPLATE, { courseId, isPublic });
  }

  getCourseTemplates(scope = null): Promise<void> {
    return Store.dispatch(COURSE_TEMPLATES_STORE.GET_COURSE_TEMPLATES, scope);
  }

  createCourseFromTemplate(courseTemplateId: number): Promise<void> {
    return Store.dispatch(COURSE_TEMPLATES_STORE.CREATE_COURSE_FROM_TEMPLATE, courseTemplateId);
  }

  getCourseTemplate(data): Promise<void> {
    return Store.dispatch(COURSE_TEMPLATES_STORE.GET_COURSE_TEMPLATE, data);
  }
  
  setTemplateMode(data: ISetTemplateModeStoreParams) {
    return Store.commit(COURSE_TEMPLATES_STORE.SET_TEMPLATE_MODE, data);
  }

  getGradeLevels(orgId) {
    return Store.dispatch(COURSE_TEMPLATES_STORE.GET_GRADE_LEVELS, orgId);
  }

  setGradeLevels(orgId) {
    return Store.commit(COURSE_TEMPLATES_STORE.SET_GRADE_LEVELS, orgId);
  }

  setGradeLevelSelected(gradeLevel) {
    return Store.commit(COURSE_TEMPLATES_STORE.SET_GRADE_LEVEL_SELECTED, gradeLevel);
  }

  getMyCourseTemplates(purchaseTypes = null, gradeLevelIds = null) {
    return Store.dispatch(COURSE_TEMPLATES_STORE.GET_MY_COURSE_TEMPLATES, {purchaseTypes, gradeLevelIds});
  }

  setMyCourseTemplates(data) {
    return Store.commit(COURSE_TEMPLATES_STORE.SET_MY_COURSE_TEMPLATES, data);
  }

  setMyContentTemplates(data) {
    return Store.commit(COURSE_TEMPLATES_STORE.SET_MY_CONTENT_TEMPLATES, data);
  }

  setPublicCourseTemplates(data) {
    return Store.commit(COURSE_TEMPLATES_STORE.SET_PUBLIC_COURSE_TEMPLATES, data);
  }

  setPrivateCourseTemplates(data) {
    return Store.commit(COURSE_TEMPLATES_STORE.SET_PRIVATE_COURSE_TEMPLATES, data);
  }

  publishCourseTemplate({templateId, templateScope}) {
    return Store.dispatch(COURSE_TEMPLATES_STORE.PUBLISH_COURSE_TEMPLATE, {templateId, templateScope});
  }

  setChangesCourseTemplates() {
    return Store.commit(COURSE_TEMPLATES_STORE.SET_CHANGES_COURSE_TEMPLATE);
  }
  
  removeCourseTemplateM(templateId) {
    return Store.commit(COURSE_TEMPLATES_STORE.REMOVE_COURSE_TEMPLATE_M, templateId);
  }

  removeCourseTemplate(templateId) {
    return Store.dispatch(COURSE_TEMPLATES_STORE.REMOVE_COURSE_TEMPLATE, templateId);
  }

  blockCourseTemplateM(templateId) {
    return Store.commit(COURSE_TEMPLATES_STORE.BLOCK_COURSE_TEMPLATE_M, templateId);
  }

  unblockCourseTemplateM(templateId) {
    return Store.commit(COURSE_TEMPLATES_STORE.UNBLOCK_COURSE_TEMPLATE_M, templateId);
  }

  blockCourseTemplate(templateId) {
    return Store.dispatch(COURSE_TEMPLATES_STORE.BLOCK_COURSE_TEMPLATE, templateId);
  }

  unblockCourseTemplate(templateId) {
    return Store.dispatch(COURSE_TEMPLATES_STORE.UNBLOCK_COURSE_TEMPLATE, templateId);
  }

  resetCourseTemplates() {
    return Store.commit(COURSE_TEMPLATES_STORE.RESET_COURSE_TEMPLATES);
  }

  setSharedTemplates(data: IResponseGetCourseTemplates): void {
    return Store.commit(COURSE_TEMPLATES_STORE.SET_SHARED_TEMPLATES, data);
  }

  updateCourseTemplateStatus(templateId: number, status: string): void {
    return Store.commit(COURSE_TEMPLATES_STORE.UPDATE_COURSE_TEMPLATE_STATUS, { templateId, status });
  }

  getCourseTemplateStatusById(templateId) {
    return Store.dispatch(COURSE_TEMPLATES_STORE.GET_COURSE_TEMPLATE_STATUS_BY_ID, templateId);
  }

  setFirstTimeContentTemplate(purchaseTypes, value : boolean): void {
    return Store.commit(COURSE_TEMPLATES_STORE.SET_FIRT_CONTENT_TEMPLATE, {purchaseTypes, value});
  }
  
}